export default (path: string) => `/blog${path}`;
